import { ReplaySubject } from 'rxjs/ReplaySubject';
var SubscriptionDisposable = /** @class */ (function () {
    function SubscriptionDisposable() {
        var _this = this;
        this._isDestroyedSubject = new ReplaySubject(1);
        if (this.ngOnDestroy !== SubscriptionDisposable.prototype.ngOnDestroy) {
            var onDestroyFunc_1 = this.ngOnDestroy.bind(this);
            this.ngOnDestroy = function () {
                onDestroyFunc_1();
                SubscriptionDisposable.prototype.ngOnDestroy.bind(_this)();
            };
        }
    }
    Object.defineProperty(SubscriptionDisposable.prototype, "isDestroyed", {
        get: function () {
            return this._isDestroyedSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    SubscriptionDisposable.prototype.ngOnDestroy = function () {
        this._isDestroyed = true;
        this._isDestroyedSubject.next(true);
        this._isDestroyedSubject.complete();
    };
    return SubscriptionDisposable;
}());
export { SubscriptionDisposable };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/subscription.disposable.ts.pre-build-optimizer.js